<template>
  <div>
    <div
      v-if="!showPopup"
      @click="showPopup = true"
      class="flex-c width-100 row-wrap"
    >
      <span v-if="type == 'company'" class="flex-c">
        <Company-Icon class="d-flex" viewBox="0 0 20 19" />
        <div class="button-text">Add company</div>
      </span>
      <span v-else class="flex-c">
        <Website-Icon class="d-flex" viewBox="0 0 20 20" />
        <div class="button-text">Try different domain</div>
      </span>
      <!-- <span class="icon-img-spacing">{{ text }}</span> -->
      <button>Find Email</button>
    </div>
    <div v-else>
      <Enter-Domain-Popup
        :data="data"
        :text="`Add company details of <span>` + data.fullName + '</span>'"
        v-on:clickedOutside="showPopup = false"
      ></Enter-Domain-Popup>
    </div>
  </div>
</template>

<script>
import companyIcon from '@/assets/icons/svg/company-2.svg'
import websiteIcon from '@/assets/icons/svg/globe-2.svg'
import enterDomainFE from '@/components/EnterDomainPopup'

export default {
  name: 'Add-Domain-Find-Email',
  props: ['text', 'type', 'data'],
  data: function () {
    return {
      showPopup: false,
    }
  },
  components: {
    'Company-Icon': companyIcon,
    'Website-Icon': websiteIcon,
    'Enter-Domain-Popup': enterDomainFE,
  },
  methods: {
    hidePopup() {
      this.showPopup = false
    },
  },
}
</script>

<style lang="scss" scoped>
.row-wrap {
  svg {
    width: 16px;
    height: 16px;
  }
  span {
    gap: 10px;
  }

  .button-text {
    background: rgba(217, 217, 217, 0.25);
    border: 1px solid rgba(125, 127, 130, 0.1);
    border-radius: 4px;
    font-size: 12px;
    line-height: 18px;
    color: #667080;
    padding: 1px 9px;
  }
  button {
    width: 102px;
    margin-left: auto;
    font-size: 12px;
    line-height: 18px;
    position: relative;
    padding: 2px 8px;
    color: #2648f7;
    background: #ffffff;
    border: 1px solid rgba(125, 127, 130, 0.25);
    border-radius: 6px;

    &:hover {
      background: #2648f7;
      border-color: #2648f7;
      color: #fff;
    }
  }
}
</style>
